import * as React from 'react'

import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin'

import { useEditor } from 'modules/core/components/TextEditor/useEditor'
import { validateUrl } from 'modules/core/components/TextEditor/utils/url'

export function LinkPlugin() {
  const editor = useEditor()

  if (!editor.isEditable()) {
    return null
  }

  return <LexicalLinkPlugin validateUrl={validateUrl} />
}
